import React, { FC } from 'react';
import { IconButton } from 'src/common/icon-button';

export interface WizardContentListCardWrapperProps {
  onDeleteClick: () => void;
  isDeleteDisabled?: boolean;
}

export const WizardContentListCardWrapper: FC<WizardContentListCardWrapperProps> = ({
  children,
  onDeleteClick,
  isDeleteDisabled = false,
}) => (
  <div className='relative bg-bedrock-white p-2 z-40 rounded-lg group pr-8' style={{ wordBreak: 'break-all' }}>
    {children}
    <div className='absolute right-2 top-2'>
      <div className='transition-opacity opacity-0 group-hover:opacity-100'>
        <IconButton disabled={isDeleteDisabled} onClick={onDeleteClick}>
          <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            className='text-bedrock-black w-5 h-5'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M7.32523 6.61788C7.12997 6.42262 6.81339 6.42262 6.61813 6.61788C6.42286 6.81314 6.42286 7.12973 6.61813 7.32499L9.29503 10.0019L6.61813 12.6788C6.42286 12.8741 6.42286 13.1906 6.61813 13.3859C6.81339 13.5812 7.12997 13.5812 7.32523 13.3859L10.0021 10.709L12.679 13.3859C12.8743 13.5812 13.1909 13.5812 13.3861 13.3859C13.5814 13.1906 13.5814 12.8741 13.3861 12.6788L10.7092 10.0019L13.3861 7.32499C13.5814 7.12973 13.5814 6.81314 13.3861 6.61788C13.1909 6.42262 12.8743 6.42262 12.679 6.61788L10.0021 9.29479L7.32523 6.61788Z'
              fill='currentColor'
            />
          </svg>
        </IconButton>
      </div>
    </div>
  </div>
);
